import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';

declare const $: any;

@Component({
    selector: 'app-question-radio-image-details',
    templateUrl: './question-radio-image-details.component.html',
    styleUrls: ['./question-radio-image-details.component.scss'],
    standalone: false
})
export class QuestionRadioImageDetailsComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input() labelText = '';
  @Output() questionAnswer = new EventEmitter<any>();

  items: any[] = [];
  uniqueControlName = `radio-image-name-${newGuid()}`;

  constructor(private questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    this.questionService.spinner(false);
  }

  ngAfterViewInit(): void {
    this.questionService.initPopoverCustomize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !==  changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;

      if (this.question?.options) {
        this.items = parseOptions(this.question.options);
        if (this.items?.length) {
          this.items.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
        }
      }
      //this.checkRadio('');
    }
    if (changes?.showLabel?.currentValue !==  changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.labelText?.currentValue !==  changes?.labelText?.previousValue) {
      this.labelText = changes?.labelText?.currentValue;
    }
    if (changes?.readOnly?.currentValue !==  changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
  }

  checkRadio(value: any): void {
    if (this.readOnly) {
      return;
    }
    if (this.question) {
      this.question.answer = value;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(value);
    }
  }
}
